// Global network logger for Supabase REST calls (opt-in via localStorage flags)
// Enable by setting one of these in the browser console:
//   localStorage.setItem('NET_DEBUG', '1')
//   localStorage.setItem('AUCTION_DEBUG', '1')
//   localStorage.setItem('ANALYTICS_DEBUG', '1')

(function attachNetworkDebug() {
  const isDebug = () =>
    localStorage.getItem('NET_DEBUG') === '1' ||
    localStorage.getItem('AUCTION_DEBUG') === '1' ||
    localStorage.getItem('ANALYTICS_DEBUG') === '1';

  if (!('fetch' in window)) return;
  if ((window as any).__networkDebugPatched) return;

  const originalFetch = window.fetch.bind(window);
  (window as any).__networkDebugPatched = true;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const start = performance.now();
    const url = typeof input === 'string' ? input : (input as Request).url;
    const shouldLog = isDebug() && /supabase\.co\/rest\/v1\//.test(url);

    let method = init?.method || (typeof input !== 'string' && (input as Request).method) || 'GET';
    let requestBody: any = undefined;
    try {
      if (init?.body && typeof init.body === 'string') {
        requestBody = JSON.parse(init.body);
      } else if (init?.body && typeof (init.body as any).getReader !== 'function') {
        requestBody = init.body;
      }
    } catch {
      requestBody = init?.body;
    }

    if (shouldLog) {
      // Truncate large payloads for readability
      const preview = requestBody && JSON.stringify(requestBody).slice(0, 1000);
      console.groupCollapsed('[NET DEBUG] Request', method, url);
      console.log('method:', method);
      console.log('url:', url);
      if (init?.headers) console.log('headers:', init.headers);
      if (requestBody) console.log('body:', preview);
      console.groupEnd();
    }

    try {
      const res = await originalFetch(input as any, init);
      const duration = Math.round(performance.now() - start);
      if (shouldLog) {
        // Clone to read safely
        const clone = res.clone();
        let bodyText = '';
        try {
          bodyText = await clone.text();
        } catch {}
        const previewRes = bodyText.slice(0, 1000);
        console.groupCollapsed('[NET DEBUG] Response', method, url, res.status, res.statusText, `${duration}ms`);
        console.log('status:', res.status);
        console.log('ok:', res.ok);
        console.log('headers:', Array.from(res.headers.entries()));
        console.log('body:', previewRes);
        console.groupEnd();
      }
      return res;
    } catch (err) {
      if (shouldLog) {
        console.group('[NET DEBUG] Fetch Error', method, url);
        console.error(err);
        console.groupEnd();
      }
      throw err;
    }
  };
})();

// Make this file a module under --isolatedModules
export {};
